<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer002">
<p class="Prelims-main">Raymond Pelly is an Anglican Priest &amp; theologian resident (since 1977) in Aotearoa, New Zealand. </p>
<p class="Prelims-main">Born in London in 1938, where he experienced the Blitz, he has worked as a teacher in Cambridge (UK), Boston/Cambridge (MA), Auckland (NZ). He is married to Barbara Craig, father of six children, two deceased. </p>
<p class="Prelims-main">His book, <em class="italic _idGenCharOverride-1">Pilgrim to Unholy Places</em>, investigates the implications of the Holocaust for Jewish-Christian dialogue and belief generally. His Heartscape poems explore ‘deep mind’, the well-springs of passionate creativity and a strong love that embraces people as well as land and seascape. </p>
<p class="Prelims-main">Raymond speaks French &amp; German; some of his best writing has been done in Contemplative/Carmelite Communities in Berlin, Weimar, Dachau &amp; Esterwegen/Emsland.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398400801_EPUB.vue?7f12a3a7